(function () {
  'use strict';

  const STORAGE_KEY = 'klosterhof-age-confirmed';
  const dialog = document.querySelector('[data-kh-age-dialog]');
  if (!dialog) return;

  const panel = dialog.querySelector('[role="dialog"]');
  const confirmButton = dialog.querySelector('[data-kh-age-confirm]');
  const cancelButtons = dialog.querySelectorAll('[data-kh-age-cancel]');
  let pendingAction = null;
  let previousFocus = null;

  function isConfirmed() {
    try { return window.sessionStorage.getItem(STORAGE_KEY) === 'yes'; } catch (error) { return false; }
  }

  function markConfirmed() {
    try { window.sessionStorage.setItem(STORAGE_KEY, 'yes'); } catch (error) { /* Continue for this checkout only. */ }
  }

  function openDialog(action) {
    pendingAction = action;
    previousFocus = document.activeElement;
    dialog.hidden = false;
    document.documentElement.classList.add('kh-age-dialog-open');
    window.requestAnimationFrame(function () {
      dialog.classList.add('is-visible');
      panel.focus();
    });
  }

  function closeDialog() {
    dialog.classList.remove('is-visible');
    document.documentElement.classList.remove('kh-age-dialog-open');
    window.setTimeout(function () { dialog.hidden = true; }, 180);
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    pendingAction = null;
  }

  confirmButton.addEventListener('click', function () {
    const action = pendingAction;
    markConfirmed();
    dialog.classList.remove('is-visible');
    document.documentElement.classList.remove('kh-age-dialog-open');
    dialog.hidden = true;
    pendingAction = null;
    if (action) action();
  });

  cancelButtons.forEach(function (button) { button.addEventListener('click', closeDialog); });
  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDialog();
  });

  document.addEventListener('click', function (event) {
    const checkoutControl = event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!checkoutControl || isConfirmed()) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    openDialog(function () {
      if (checkoutControl.matches('a')) {
        window.location.assign(checkoutControl.href);
        return;
      }
      const form = checkoutControl.form || checkoutControl.closest('form');
      if (form) form.requestSubmit(checkoutControl);
    });
  }, true);

  document.addEventListener('submit', function (event) {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout' || isConfirmed()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openDialog(function () { submitter.form.requestSubmit(submitter); });
  }, true);
})();
